module.exports = __webpack_public_path__ + "static/media/danica.0d6c3051.jpg";